'use client'

import { UserItem } from "@/lib/types/user/user"
import { useSession } from "next-auth/react"

export const useCurrentUser: () => UserItem | null = () => {
  const { data: session, status } = useSession()
  
  if (status === "loading") {
    return null
  }
  
  return session?.user ?? null
}
